import { Suspense } from "react";
import { Outlet, useLocation } from "react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/layout/AppLayout";
import { PartnerLayout } from "@/components/partner-shell/PartnerLayout";
import { useInternalUi } from "@/hooks/useInternalUi";
import { Loader } from "@/components/common/Loader";

// Content-area fallback for lazily-loaded route chunks. Sits INSIDE AppLayout so
// the sidebar/header persist while the next page's chunk loads.
function RouteFallback() {
  return (
    <div className="flex flex-1 items-center justify-center py-16">
      <Loader size={32} />
    </div>
  );
}

// Shared layout for every authenticated module: auth gate + app chrome applied
// once here, so individual pages no longer wrap themselves in ProtectedRoute /
// AppLayout. Matched routes render into the <Outlet/>.
export default function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <Chrome>
        <Suspense fallback={<RouteFallback />}>
          <Outlet />
        </Suspense>
      </Chrome>
    </ProtectedRoute>
  );
}

// Internal staff get the new frame; agents and partners keep today's (useInternalUi).
function Chrome({ children }: { children: React.ReactNode }) {
  const internal = useInternalUi();
  const location = useLocation();
  if (location.pathname === "/outreach" && new URLSearchParams(location.search).get("embed") === "1") return <>{children}</>;
  return internal ? <AppLayout>{children}</AppLayout> : <PartnerLayout>{children}</PartnerLayout>;
}
